import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { MOCKUP_URL, heroChecks } from '../../data/content';
type HeroProps = {
  ctaRef: React.RefObject<HTMLAnchorElement>;
};
export function Hero({
  ctaRef
}: HeroProps) {
  return <header className="relative bg-ink-900 text-white" data-id="element-192" data-mp="hvz2tvkataee">
      <div className="bg-brand-500 px-4 py-2 text-center text-[13px] font-bold uppercase tracking-wide text-ink-950" data-id="element-193" data-mp="mu0o8n575lt1">
        For Endodontists & Dental Professionals
      </div>
      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-14 pt-8 md:px-8 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-20 lg:pt-14" data-id="element-194" data-mp="qtj8dgp71sut">
        <div className="text-center lg:text-left" data-id="element-195" data-mp="10loyekvvy07d">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-196" data-mp="10njixy38vqax">
            Endodontic Retreatment Decision Blueprint™
          </p>
          <h1 className="mt-3 text-[30px] font-extrabold leading-[1.12] tracking-tight sm:text-4xl lg:text-[48px]" data-id="element-197" data-mp="1akoa6cby6byl">
            Organize Your Next Complex Endodontic Retreatment Assessment Into{' '}
            <span className="text-cta-400" data-id="element-198" data-mp="4noh41behcnz">5 Clear Decision Steps</span> — Using One Practical Clinical Blueprint
          </h1>
          <p className="mt-5 text-[17px] leading-relaxed text-mist-200 lg:text-lg" data-id="element-199" data-mp="3vvas6f0g8hev">
            Turn persistent symptoms, uncertain radiographic findings, and previously treated teeth into a structured
            assessment, documentation, and treatment-planning workflow.
          </p>
        </div>

        <div className="lg:row-span-2" data-id="element-200" data-mp="nfzejfnaciep">
          <img src={MOCKUP_URL} alt="Endodontic Retreatment Decision Blueprint — 6 volumes and 5 bonuses" className="mx-auto w-full max-w-[560px]" data-id="element-201" data-mp="io91v30vlik4" />
        </div>

        <div className="space-y-6" data-id="element-202" data-mp="1b5bowiucmwil">
          <p className="text-center text-[16px] leading-relaxed text-mist-200 lg:text-left" data-id="element-203" data-mp="1b6cwueg2j2w3">
            Introducing the <strong className="text-white" data-id="element-204" data-mp="16csajjnu7xcq">ENDO RETREATMENT DECISION PATHWAY™</strong> — a practical,
            five-step framework designed to help qualified dental professionals organize clinical findings, compare
            management options, and document their reasoning.
          </p>
          <ul className="grid gap-2.5 rounded-2xl bg-ink-800 p-5 ring-1 ring-white/10" data-id="element-205" data-mp="2qvktujz48lrm">
            {heroChecks.map(c => <li key={c} className="flex items-center gap-3 text-[16px] font-semibold" data-id="element-206" data-mp="2vsujo0qf2zfz">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-400 text-ink-950" data-id="element-207" data-mp="2hxiltkgyssuu">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-208" data-mp="27xi3a0qx6grp" />
                </span>
                {c}
              </li>)}
          </ul>
          <div className="text-center lg:text-left" data-id="element-209" data-mp="2cyfl2c80p8so">
            <p className="text-lg font-bold text-mist-200" data-id="element-210" data-mp="66yaks6ojql6">
              Get the complete blueprint for just{' '}
              <span className="text-3xl font-extrabold text-cta-400" data-id="element-211" data-mp="b4g7tlbc4hdc">$27</span>
            </p>
          </div>
          <CtaButton ref={ctaRef} label="Yes! I want my Retreatment Decision Blueprint" data-id="element-212" data-mp="1vnaa2xy7v1un" />
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-medium text-mist-300 lg:justify-start" data-id="element-213" data-mp="1qpii63xknfqg">
            <span className="flex items-center gap-1.5" data-id="element-214" data-mp="20m3nyrhf0uvc"><ZapIcon className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-215" data-mp="20l2akgcxfwag" />Instant Digital Access</span>
            <span className="flex items-center gap-1.5" data-id="element-216" data-mp="2ec74d1tm5ucv"><CreditCardIcon className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-217" data-mp="2efcvsnppt8br" />One-Time Payment</span>
            <span className="flex items-center gap-1.5" data-id="element-218" data-mp="2obo6xadkjs4m"><ShieldCheckIcon className="h-4 w-4 text-brand-300" aria-hidden="true" data-id="element-219" data-mp="2oamtiz92ytjq" />7-Day Guarantee</span>
          </div>
        </div>
      </div>
    </header>;
}